import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';
import './TrackModal.css';

const TrackModal = ({ track, onClose }) => {
  const { t } = useTranslation();
  const [showLyrics, setShowLyrics] = useState(false);

  const platformNames = {
    spotify: 'Spotify',
    appleMusic: 'Apple Music',
    youtube: 'YouTube',
    youtubeMusic: 'YouTube Music',
    tidal: 'Tidal',
    bandcamp: 'Bandcamp',
    soundcloud: 'SoundCloud'
  };

  const getPlatformIcon = (platform) => {
    const iconProps = { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor" };
    
    switch (platform) {
      case 'spotify':
        return (
          <svg {...iconProps}>
            <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.84-.179-.96-.539-.12-.421.18-.84.54-.96 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.302 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z"/>
          </svg>
        );
      case 'appleMusic':
        return (
          <svg {...iconProps}>
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm-1 14.5l6-3.5-6-3.5v7z"/>
          </svg>
        );
      case 'youtube':
        return (
          <svg {...iconProps}>
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
          </svg>
        );
      case 'youtubeMusic':
        return (
          <svg {...iconProps}>
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
          </svg>
        );
      case 'tidal':
        return (
          <svg {...iconProps}>
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2z"/>
            <path d="M7 8h2v8H7V8zm4-2h2v10h-2V6zm4 4h2v6h-2v-6z"/>
          </svg>
        );
      case 'bandcamp':
        return (
          <svg {...iconProps}>
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2z"/>
            <path d="M8 9l4 6h-4l-4-6h4z"/>
          </svg>
        );
      case 'soundcloud':
        return (
          <svg {...iconProps}>
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2z"/>
            <path d="M6 14h12v2H6v-2zm1-2h10v2H7v-2zm2-2h6v2H9v-2z"/>
          </svg>
        );
      default:
        return (
          <svg {...iconProps}>
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm-1 14.5l6-3.5-6-3.5v7z"/>
          </svg>
        );
    }
  };

  // Normalize YouTube URL to ensure proper format
  const normalizeUrl = (url) => {
    if (!url) return url;
    let videoId = null;
    
    // Extract video ID from various YouTube URL formats
    if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('youtube.com/watch?v=')[1]?.split('&')[0];
    } else if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1]?.split('?')[0];
    } else if (url.includes('youtube.com/embed/')) {
      videoId = url.split('youtube.com/embed/')[1]?.split('?')[0];
    }
    
    if (videoId) {
      return `https://www.youtube.com/watch?v=${videoId}`;
    }
    
    return url;
  };

  const playerUrl = track?.playUrl ? normalizeUrl(track.playUrl) : null;

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    // Store original styles
    const originalOverflow = document.body.style.overflow;
    const originalPaddingRight = document.body.style.paddingRight;
    const originalTransition = document.body.style.transition;
    
    // Disable body transitions temporarily to prevent blinking
    document.body.style.transition = 'none';
    
    // Calculate scrollbar width before hiding scroll
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    
    // Apply styles synchronously to prevent blinking
    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
    
    // Re-enable transitions after a brief delay
    requestAnimationFrame(() => {
      document.body.style.transition = originalTransition || '';
    });
    
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
      // Restore original styles
      document.body.style.overflow = originalOverflow;
      document.body.style.paddingRight = originalPaddingRight;
      document.body.style.transition = originalTransition;
    };
  }, [onClose]);

  // Debug: log the URL being used
  useEffect(() => {
    if (playerUrl) {
      console.log('Player URL:', playerUrl);
    }
  }, [playerUrl]);

  if (!track) return null;

  return (
    <div className="track-modal" onClick={onClose}>
        <button className="track-modal-close" onClick={onClose} aria-label="Close">
          ✕
        </button>
      <div className="track-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="track-modal-artwork">
          <img 
            src={track.artwork || '/placeholder-track.jpg'} 
            alt={track.name}
            onError={(e) => {
              e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect fill="%239D4EDD" width="400" height="400"/%3E%3Ctext fill="white" font-family="Arial" font-size="24" x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3E' + track.name + '%3C/text%3E%3C/svg%3E';
            }}
          />
        </div>

        <div className="track-modal-info">
          <h2 className="track-modal-name">{track.name}</h2>
          {track.album && (
            <p className="track-modal-album">{track.album}</p>
          )}
          
          {track.comingSoon ? (
            <div className="track-modal-coming-soon">
              <div className="coming-soon-badge-large">{t('music.comingSoon')}</div>
              <p className="coming-soon-message">{t('music.comingSoonMessage')}</p>
            </div>
          ) : (
            <>
              {playerUrl && (
                <div className="track-modal-player">
                  <ReactPlayer
                    src={playerUrl}
                    width="100%"
                    height="300px"
                    controls={true}
                    playing={false}
                    pip={false}
                    fallback={<div>Loading player...</div>}
                    config={{
                      youtube: {
                        playerVars: {
                          showinfo: 0,
                          rel: 0,
                          modestbranding: 1,
                          enablejsapi: 1,
                          autoplay: 0
                        }
                      },
                      soundcloud: {
                        options: { show_artwork: false }
                      }
                    }}
                    onError={(error) => {
                      console.error('ReactPlayer error:', error);
                    }}
                  />
                </div>
              )}
              
              {track.lyrics && track.lyrics.length > 0 && (
                <div className="track-modal-lyrics-section">
                  <button
                    className="track-modal-lyrics-toggle"
                    onClick={() => setShowLyrics(!showLyrics)}
                    aria-expanded={showLyrics}
                  >
                    <span className="lyrics-toggle-icon">{showLyrics ? '▼' : '▶'}</span>
                    <span>{t('music.lyrics')}</span>
                  </button>
                  {showLyrics && (
                    <div className="track-modal-lyrics-content">
                      <div className="track-modal-lyrics-text">
                        {Array.isArray(track.lyrics) ? (
                          track.lyrics.map((line, index) => (
                            <span 
                              key={index} 
                              className={`lyrics-line ${line === '' ? 'lyrics-line-empty' : ''}`}
                            >
                              {line || '\u00A0'}
                            </span>
                          ))
                        ) : (
                          // Backward compatibility: if lyrics is a string, split by newlines
                          track.lyrics.split('\n').map((line, index) => (
                            <span 
                              key={index} 
                              className={`lyrics-line ${line === '' ? 'lyrics-line-empty' : ''}`}
                            >
                              {line || '\u00A0'}
                            </span>
                          ))
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
              
              <div className="track-modal-platforms">
                <h3 className="track-modal-platforms-title">{t('music.listenOn')}</h3>
                <div className="track-modal-platforms-list">
                  {Object.entries(track.platforms || {}).map(([platform, url]) => (
                    <a
                      key={platform}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="track-modal-platform-link"
                      aria-label={`${t('music.listenOn')} ${platformNames[platform] || platform}`}
                    >
                      <span className="track-modal-platform-icon">
                        {getPlatformIcon(platform)}
                      </span>
                      <span className="track-modal-platform-name">{platformNames[platform] || platform}</span>
                    </a>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrackModal;

